export const actionTypes = {
    LOADER: "LOADER",
    BRANCH_LIST : "BRANCH_LIST",
    MEMBER_LIST: "MEMBER_LIST",
    CREDIT_LIST: "CREDIT_LIST",
    ROLE_LIST: "ROLE_LIST",
    ZONE_WISE_BRANCH_LIST: "ZONE_WISE_BRANCH_LIST",
    ALL_BRANCH_LIST: "ALL_BRANCH_LIST",
};

const INITIAL_STATE = {
    vfsuklploader: false,
    BranchList: [],
    MemberList: [],
    CreditList: [],
    RoleList: [],
    ZoneWiseBranchList: [],
    AllBranchList: [],
};

const VfsuklpReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.LOADER:
            return {
                ...state,
                vfsuklploader: action.vfsuklploader,
            };
        case actionTypes.BRANCH_LIST:
            return {
                ...state,
                BranchList: action.BranchList,
            };
        case actionTypes.MEMBER_LIST:
            return {
                ...state,
                MemberList: action.MemberList,
            };
        case actionTypes.CREDIT_LIST:
            return {
                ...state,
                CreditList: action.CreditList,
            };
        case actionTypes.ROLE_LIST:
            return {
                ...state,
                RoleList: action.RoleList,
            };
        case actionTypes.ZONE_WISE_BRANCH_LIST:
            return {
                ...state,
                ZoneWiseBranchList: action.ZoneWiseBranchList,
            };
        case actionTypes.ALL_BRANCH_LIST:
            return {
                ...state,
                AllBranchList: action.AllBranchList,
            };
        default:
            return state;
    }
};

export default VfsuklpReducer;
